import styled from "styled-components";
import DatePicker from "react-datepicker";

export const TextFull = styled.p<{isDisabled?: boolean}>`
  color: #637381;
  border-radius: 7px;
  border: 1px solid #dfe4ea;
  padding: 8px 15px;
  font-size: 0.875rem;

  -webkit-appearance: ${({isDisabled}) => (isDisabled ? "none !important" : "")};
  appearance: ${({isDisabled}) => (isDisabled ? "none !important" : "")};
  background-color: ${({isDisabled}) => (isDisabled ? "#f3f3f3 !important" : "")};
  background-image: ${({isDisabled}) =>
    isDisabled ? " linear-gradient(to right, #f3f3f3, #f3f3f3) !important" : ""};
  color: ${({isDisabled}) => (isDisabled ? "rgb(99, 115, 129) !important" : "")};
  -webkit-text-fill-color: ${({isDisabled}) => (isDisabled ? "rgb(99, 115, 129) !important" : "")};
  opacity: ${({isDisabled}) => (isDisabled ? "1 !important" : "")};
  pointer-events: ${({isDisabled}) => (isDisabled ? "none" : "")};
`;

export const Container = styled.div<{isMobileScreen: boolean}>`
  padding-top: ${({isMobileScreen}) => (isMobileScreen ? `190px` : `0px`)};
  max-width: 1142px;
  width: 90%;
  margin: 0px auto;
  margin-bottom: 20px;
  margin-top: 0px;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  .custom-fixed {
    border-radius: 10px;
    box-shadow: 0px 3px 7px #00000052;
    background-color: lightgray;
  }
`;

export const SearchBlock = styled.div`
  padding: 7px 15px;
  input {
    width: 100%;
  }
  .title {
    color: #333333;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 0.75rem;
  }
  .center-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  h2 {
    font-weight: 700;
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
  p {
    font-size: 0.6875rem;
  }
`;

export const MobileSearch = styled.div`
  position: fixed;
  background-color: #e4e4e4;
  z-index: 99999999;
  top: 0;
  left: 0;
  width: 100vw;
  padding: 50px 0 0 0;
  height: 100svh;
  overflow-y: auto;
  transition: 200ms ease-in-out;

  .close-button {
    float: right;
    margin-right: 20px;
  }
  form {
    margin-top: 20px;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  min-height: 38px;
  outline: 0 !important;
  background-color: hsl(0, 0%, 100%);
  border-radius: 7px;
  border: 1px solid rgb(223, 228, 234);
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  width: 100% !important;
  font-size: 0.875rem;
  padding-left: 10px;
  color: rgb(99, 115, 129);
`;

export const WrappedDatePicker = styled.div`
  .react-datepicker {
    display: flex;
  }

  .react-datepicker__month-container {
    position: relative;
  }

  .react-datepicker__month-container:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background-color: #aeaeae;
  }

  .react-datepicker-wrapper {
    width: 100% !important;
  }

  .react-datepicker__day--in-selecting-range {
    background-color: white !important;
    color: black !important
  }

  .react-datepicker__day--selecting-range-start {
    background-color: #0971A2 !important;
    color: white !important
  }

  .react-datepicker__day:hover {
    background-color: #95c4e5 !important;
    color: white !important
  }
`;

export const MobileWrappedDatePicker = styled.div`
  .react-datepicker-wrapper {
    width: 100% !important;
  }

  .react-datepicker__day--in-selecting-range {
    background-color: white !important;
    color: black !important
  }

  .react-datepicker__day--selecting-range-start {
    background-color: #0971A2 !important;
    color: white !important
  }
`;
